import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';
import { RecomendacaoItemMenuModel } from './RecomendacaoItemMenuModel';

export class RecomendacaoMenuModel {
    titulo: String
    menu: Array<RecomendacaoItemMenuModel>
    icone: String = "../../../assets/img/transparente.png"

    static TIPO_ACOES_BOLSA = "B"
    static TIPO_FUTUROS_BOLSA = "F"
    static TIPO_CRIPTOMOEDAS = "C"
    static TIPO_FUNDOS_IMOBILIARIOS = "FII"
    static TIPO_FUNDOS_INDICE = "ETF"
    static TIPO_INDICES = "INDICE"
    static TIPO_EUA = "EUA"
    static TIPO_BDR = "BDR"

    static MENU_ITEM_OPERACOES_NO_DIA = 1
    static MENU_ITEM_CURTO_PRAZO = 2
    static MENU_ITEM_LONGO_PRAZO = 3

    static PN_OPERACOES_NO_DIA = 'pn_operacoes_no_dia'
    static PN_CURTO_PRAZO = 'pn_curto_prazo'
    static PN_LONGO_PRAZO = 'pn_longo_prazo'

    getMenuRecomendacoes(tipoMenu: String): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/recomendacoes/' + tipoMenu + '/categorias2')
    }
}